export default __webpack_public_path__ + "static/media/img-trofeu-bbm.c0556530.png";